import React from "react";
import Logo from "./iradar-logo.png";
const IRadarLogo = () => {
  return <img src={Logo} alt="iRadar Logo" className="iradar-logo" />;
};

export default IRadarLogo;
